import { RemoveGroupModal } from "./RemoveGroupModal";

export default RemoveGroupModal;
